/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';
import config from '@config';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { Downloadform } from './Download-form';

export const HostGuide = ({ sectionContent, region, lang }) => {
  const titleData =
    sectionContent?.find(item => item._modelApiKey === 'msr_section_title') ||
    sectionContent?.[0];

  const listData =
    sectionContent?.find(item => item._modelApiKey === 'structured_tex') ||
    sectionContent?.[1];

  const downloadData =
    sectionContent?.find(item => item._modelApiKey === 'json_table') ||
    sectionContent?.[2];

  return (
    <Box
      w="100%"
      backgroundImage={`url('${config.imgPath}/d/46272/1739791359-host-guide.jpg')`}
      bgSize="cover"
      bgPos="center"
      bgRepeat="no-repeat"
      py={{ base: '18px', md: '76px' }}
      px={{ base: '18px', md: '102px' }}
      id="download-host-guide-section"
    >
      <Box
        maxW="765px"
        mx="auto"
        bgColor="#03062C"
        color="#fff"
        px={{ base: '18px', lg: '102px' }}
        py={{ base: '41px', lg: '79' }}
        display="flex"
        justifyContent="center"
      >
        <Box maxW="562px">
          <Box
            display="flex"
            flexDirection="column"
            gap={{ base: '15px', md: '25px' }}
          >
            <MsrSectionTitle pt="0" mt="0" titleObj={titleData} />
            <StructuredTextParser
              className="host-structured-text"
              fontFamily={'FedraSansStd-book'}
              fontWeight={400}
              ml={{ base: '1rem', md: '0' }}
              fontSize={{ base: '16px', md: '18px' }}
              lineHeight={{ base: '26px' }}
              str={render(listData?.body)}
              ps={{ base: '15px', md: '20px', lg: '35px' }}
              pe={{ base: '0', lg: '31px' }}
            />
          </Box>
          <Downloadform downloadData={downloadData} />
        </Box>
      </Box>
      <style jsx global>
        {`
          .host-structured-text p {
            margin-bottom: 16px;
          }
        `}
      </style>
    </Box>
  );
};
